import React, { Fragment, useEffect, useState } from "react";
import {
  FormGroup,
  Input,
  Label,
  Button,
  Form,
  FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import { addGroupCreate, clearCreateGroupError, createGroup } from "../../../store/deviceDetails/actions.js";
import Message from "../../../CommonData/Data/Message.js";
import { updateForm } from "../../../store/form/actions.js";
import VWLoading from "../../../components/vwLoading/vwLoading.js";

const CreateGroupForm = (props) => {

  const { form, isPending } = props || {};

  useEffect(() => {
    props.updateForm({
      formAddGroup: {},
      errors: {}
    })
    props.clearCreateGroupError()
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [])

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    props.updateForm({
      formAddGroup: {
        ...form.formAddGroup,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });

  }

  const handleCreateGroup = (e) => {
    e.preventDefault();
    const { masterDeviceDetails } = props;
    const { formAddGroup } = form || {};
    const { name } = formAddGroup || {};
    const currentErrors = {};

    if (!name) {
      currentErrors.name = "Group name is required"
    }
    props.updateForm({
      formAddGroup: {
        ...form.formAddGroup,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.createGroup(form.formAddGroup, masterDeviceDetails.id);
    }
  };
  const { handleClose, errorMessage } = props;
  return isPending ? (<VWLoading />) : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form onSubmit={handleCreateGroup}>
        <FormGroup>
          <Label>
            Group Name<span className="text-danger">*</span>
          </Label>
          <Input
            autoFocus
            type="text"
            name="name"
            placeholder="Enter group name"
            onChange={handleInputChange}
            invalid={form && form.errors && form.errors.name}
          />
          <FormFeedback>{form && form.errors && form.errors.name}</FormFeedback>
        </FormGroup>
      </Form>
      <FormGroup>
        <Button
          type="submit"
          color="success"
          onClick={handleCreateGroup}
        >Create
        </Button>&nbsp;&nbsp;
        <Button
          color="danger"
          onClick={handleClose}
        >Cancel
        </Button>
      </FormGroup>
    </Fragment>
  );

}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isPending: state.deviceDetails.isCreateGroupPending,
  errorMessage: state.deviceDetails.createGroupErrorMessage,
  masterDeviceDetails: state.deviceDetails.masterDevice,
});

const mapDispatchToProps = (dispatch) => ({
  addGroupCreate: (AddGroup) => dispatch(addGroupCreate(AddGroup)),
  updateForm: (AddGroup) => dispatch(updateForm(AddGroup)),
  createGroup: (AddGroup, masterDeviceId) => dispatch(createGroup(AddGroup, masterDeviceId)),
  clearCreateGroupError: () => dispatch(clearCreateGroupError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateGroupForm);
